import * as React from 'react'
import { Spacer } from '../../../../common/src/components/core'
import { FirmType, FetchFirmDetailsQuery, Firm } from '../../../../common/src/types.gen'
import validate from '../../../../common/src/validate'
import { Field } from '../components/EditBox'
import EditBoxes from '../components/EditBoxes'
import EmailCalSystems from './EmailCalSystems'
import PropertyManagementSystems from './PropertyManagementSystems'

const firmTypes: FirmType[] = [FirmType.ADMIN, FirmType.LEASING, FirmType.DISABLED]

const fieldFirmType: Field<string> = {
  key: 'firmType',
  isEditable: true,
  options: firmTypes,
}

const fieldConfig: Field<string> = {
  key: 'config',
  label: 'Config',
  isEditable: true,
  colorFunc: val => (val == null ? 'coral' : undefined),
  validator: validate.json(),
  isOptional: true,
}

const fieldsAll = [fieldFirmType]
const fieldsConfig = [fieldConfig]

interface FirmEditBoxesProps {
  firmInfo: (Firm & { config: string | null }) | FetchFirmDetailsQuery['firm']
  onEdit?: (key: string, value: any) => Promise<any>
  canViewFirmSecrets?: boolean
}

export default class FirmEditBoxes extends React.PureComponent<FirmEditBoxesProps> {
  render() {
    const { firmInfo, onEdit, canViewFirmSecrets } = this.props

    return (
      <div>
        <EditBoxes model={firmInfo} fields={fieldsAll} onEdit={onEdit} displayType="small" />
        <EditBoxes model={firmInfo} fields={fieldsConfig} onEdit={onEdit} displayType="code" />

        {canViewFirmSecrets && (
          <>
            <Spacer height={64} />
            <EmailCalSystems firmInfo={firmInfo as FetchFirmDetailsQuery['firm']} />
            <Spacer height={64} />
            <PropertyManagementSystems firmInfo={firmInfo as FetchFirmDetailsQuery['firm']} />
          </>
        )}
      </div>
    )
  }
}
